import { render, staticRenderFns } from "./EventFormUpload.vue?vue&type=template&id=68ef9eda&scoped=true"
import script from "./EventFormUpload.vue?vue&type=script&lang=js"
export * from "./EventFormUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef9eda",
  null
  
)

export default component.exports